const level = 0;
export default {
  enableWorker: true,
  lowLatencyMode: true,
  backBufferLength: 90,
  level,
  currentLevel: level,
  debug: false,
};
